import {AppearanceProvider} from 'components/common/CartItemBuilder/providers/AppearanceProvider'
import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {Basic, Ventrata} from 'types'
import {CostFromPerBooking} from './CostFromPerBooking'
import {CostFromPerUnit} from './CostFromPerUnit'

type Props = {
  product: Ventrata.Product
  option: Ventrata.Option
  currency: Basic.Currency
}

export const CostFrom = ({product, option, currency}: Props) => {
  const {stepOrder} = AppearanceProvider.useManager()
  const date = InputProvider.useDate('optional')
  const calendar = VentrataDataProvider.useCalendarByOptionId(option.id, 'optional')
  const calendarDay =
    calendar && date && stepOrder === 'guestsFirst' ? calendar.find((day) => day.localDate === date) ?? null : null

  switch (product.pricingPer) {
    case 'BOOKING':
      return <CostFromPerBooking option={option} currency={currency} calendarDay={calendarDay} />

    case 'UNIT':
      return <CostFromPerUnit option={option} currency={currency} calendarDay={calendarDay} />

    default:
      return null
  }
}
